
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indextaeU1Rv2PODclhn_AsI5UxzQ2xvK5IkFXgTj7NPk3QMMeta } from "/home/runner/work/1/s/pages/index.vue?macro=true";
import { default as indexIhHY_ViQrSqqCLJKDJ723yTYhtbuLiGVxu9WbsoCYKUMeta } from "/home/runner/work/1/s/pages/marketplace/index.vue?macro=true";
import { default as indexzkD5QlTHSU4nSpmOCngPvsn6sUZSzAt4YZTXrnyCcTkMeta } from "/home/runner/work/1/s/pages/marketplace/news/index.vue?macro=true";
import { default as index9h2sSVT5_45_UixXD_hkX3a6P14xQDQfK8l5hIGNr6_YEMeta } from "/home/runner/work/1/s/pages/marketplace/search/index.vue?macro=true";
import { default as indexpsVTI_hQN2ssw_PJKXpw_IoX0MXIAVu6bbB5_45z4FPAwMeta } from "/home/runner/work/1/s/pages/marketplace/support/index.vue?macro=true";
import { default as indexaxSOvOcv5eT1YOe1h2kX2afUTaE_45fQQ2nGWblKsuz1cMeta } from "/home/runner/work/1/s/pages/marketplace/about-us/index.vue?macro=true";
import { default as index8K1sJp_45kLY6rP6HCvAqcsctAKqFNp9wD_K8BUSxiHNAMeta } from "/home/runner/work/1/s/pages/marketplace/partners/index.vue?macro=true";
import { default as indexY9XveV6TxZfvx7eAOrvgb12BFY3Qbc2AowYuCEwiy2YMeta } from "/home/runner/work/1/s/pages/marketplace/webinars/index.vue?macro=true";
import { default as indexQ7lrb305SpAZsFDN95cwJVXOYQvlWmnQbHmzIf2faT8Meta } from "/home/runner/work/1/s/pages/marketplace/free-trial/index.vue?macro=true";
import { default as index90Q9l6A4EhY_uiFRMbi8PJhvAhlceJgztwvKWGU7VKsMeta } from "/home/runner/work/1/s/pages/marketplace/Membership/index.vue?macro=true";
import { default as indexH280oFFxg1z0kzTA1nscMXj2pKRfvLY9IVe5fGu3Mu0Meta } from "/home/runner/work/1/s/pages/marketplace/pricing/[id]/index.vue?macro=true";
import { default as _91details_93m0G3M9Dv1x53wRqsCabJ6zRM_45a5oh3rvV0nF41Nxu30Meta } from "/home/runner/work/1/s/pages/marketplace/materials/[details].vue?macro=true";
import { default as index06FdUtUOAmONErkzGVdrxAzj0LJTaPj_xkeD_127X3kMeta } from "/home/runner/work/1/s/pages/marketplace/products/[id]/index.vue?macro=true";
import { default as indexXn__xx3w3i4kFetLsSMLl6EsP9g2lWaeHuK51mTRkd4Meta } from "/home/runner/work/1/s/pages/marketplace/help/contact-us/index.vue?macro=true";
import { default as _91_46_46_46slug_93L4neUMNJ4BuKhcc1kgX2s_45wXHqHU9B8nwkWMCcpSG1YMeta } from "/home/runner/work/1/s/pages/marketplace/products/[id]/[...slug].vue?macro=true";
import { default as indexolPTTBdH2egg5BicYOeakk48X85PLk59dkvkq_453blxUMeta } from "/home/runner/work/1/s/pages/marketplace/help/sales-support/index.vue?macro=true";
import { default as index8zeojeTel9Lime7ZIVPGww4QIAmWvkX_45wJLaLhnlLGkMeta } from "/home/runner/work/1/s/pages/marketplace/support/support-hub/index.vue?macro=true";
import { default as indexa280vM9__4C8Fapng9aB_45Rr_45CoaeOQXS1Xn9fsOAVmkMeta } from "/home/runner/work/1/s/pages/marketplace/solutions/[solution]/index.vue?macro=true";
import { default as indextRBs6RYD7aJ9tQHJOuZUmM2_45keSLqJIJjm7FOIxStLkMeta } from "/home/runner/work/1/s/pages/marketplace/category/[subcategory]/index.vue?macro=true";
import { default as index_M3xq0JtKdf2qN_45M1pWfRTRHN16QNY11JknR_HYPwgYMeta } from "/home/runner/work/1/s/pages/marketplace/help/technical-support/index.vue?macro=true";
import { default as indexL4OeEmtLqEu1P2aNYX82vTDH9hDquRgDUo6NBM_LTBEMeta } from "/home/runner/work/1/s/pages/marketplace/redirect/report-center/index.vue?macro=true";
import { default as indexXXiM3eRblJWO7SCYcyms9EJw_XNj74sxw_Ye39VDs7cMeta } from "/home/runner/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue?macro=true";
import { default as indexHJFTCGvFI6itrYF6BG8W7r3SslSLXF_45J9vR0JfMKhpcMeta } from "/home/runner/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue?macro=true";
import { default as indexLyK7GnSUj8df_RrLwik58Dh3l6r_45A_piaxGpxWvAhUwMeta } from "/home/runner/work/1/s/pages/marketplace/partners/program-overview/index.vue?macro=true";
import { default as _91generic_93fOjF2IINMlEbJu4CcfWUI6Ou1q4rq7Ijv7uamlWbOtkMeta } from "/home/runner/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue?macro=true";
import { default as indexc3BGDYZYAcOFeVX_45aWQysF_454h9uxzOQtwn_pd3w1rF0Meta } from "/home/runner/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue?macro=true";
import { default as indexrpUvACVFEKDfTIZdFDlQdPOhuDXt30G4oVA2HDrBpdsMeta } from "/home/runner/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue?macro=true";
import { default as indexDPHxqvvn8XP6QINCLRG1DO913HcmlABkl6HWPLf1qawMeta } from "/home/runner/work/1/s/pages/marketplace/support/certificated-sales/index.vue?macro=true";
import { default as indexHKFK_45vTF_QNxXX_b1fEGy_tWDddxoNwWNUcDudhWXYoMeta } from "/home/runner/work/1/s/pages/marketplace/partners/si-partner-program/index.vue?macro=true";
import { default as indexXnkPerO921Ge3IJcaNFkWIfLXivUENNQIpOATCRgSPcMeta } from "/home/runner/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue?macro=true";
import { default as indextfGf4KtVmTv7smR3h86gY_7xI9QZv7Bl8YWDqzydHKAMeta } from "/home/runner/work/1/s/pages/marketplace/partners/isv-partner-program/index.vue?macro=true";
import { default as indexeua2IXmkqsUlo1cSSWY3M4xjKTELaib_45t5TQMkK_Di0Meta } from "/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue?macro=true";
import { default as indexAoEwi5ZScWEw6cl9_XPaIhs90idOiZIxOd1nXmQv0V4Meta } from "/home/runner/work/1/s/pages/marketplace/partners/channel-partner-program/index.vue?macro=true";
import { default as indexg58whGZhe1IQdhOcMWTy66cm_45J2wT75LzPUSDigajwMMeta } from "/home/runner/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue?macro=true";
import { default as index_9e7GLRcY7W5GgueJSsy5Petq5G6FFzSuByIUA07zFcMeta } from "/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue?macro=true";
import { default as indexQ1J2bACr5bZ8cseDyvOUUzWBSVvPeG8yI_459pL_45D6YpUMeta } from "/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue?macro=true";
import { default as index1MW_45u_45e6Ygpebp4KWmJ7QxhJ_45SHji8KaMT2vjdnyndEMeta } from "/home/runner/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue?macro=true";
import { default as index9I4qsKzJU8lUfLrRUbOevhYiVVE2EcO7V52nXiciEqQMeta } from "/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue?macro=true";
import { default as component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pwMeta } from "/home/runner/work/1/s/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pw } from "/home/runner/work/1/s/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indextaeU1Rv2PODclhn_AsI5UxzQ2xvK5IkFXgTj7NPk3QMMeta || {},
    component: () => import("/home/runner/work/1/s/pages/index.vue")
  },
  {
    name: "index___en-int",
    path: "/en-int",
    meta: indextaeU1Rv2PODclhn_AsI5UxzQ2xvK5IkFXgTj7NPk3QMMeta || {},
    component: () => import("/home/runner/work/1/s/pages/index.vue")
  },
  {
    name: "index___en-emea",
    path: "/en-emea",
    meta: indextaeU1Rv2PODclhn_AsI5UxzQ2xvK5IkFXgTj7NPk3QMMeta || {},
    component: () => import("/home/runner/work/1/s/pages/index.vue")
  },
  {
    name: "index___en-jp",
    path: "/en-jp",
    meta: indextaeU1Rv2PODclhn_AsI5UxzQ2xvK5IkFXgTj7NPk3QMMeta || {},
    component: () => import("/home/runner/work/1/s/pages/index.vue")
  },
  {
    name: "index___en-tw",
    path: "/en-tw",
    meta: indextaeU1Rv2PODclhn_AsI5UxzQ2xvK5IkFXgTj7NPk3QMMeta || {},
    component: () => import("/home/runner/work/1/s/pages/index.vue")
  },
  {
    name: "index___en-kr",
    path: "/en-kr",
    meta: indextaeU1Rv2PODclhn_AsI5UxzQ2xvK5IkFXgTj7NPk3QMMeta || {},
    component: () => import("/home/runner/work/1/s/pages/index.vue")
  },
  {
    name: "index___en-americas",
    path: "/en-americas",
    meta: indextaeU1Rv2PODclhn_AsI5UxzQ2xvK5IkFXgTj7NPk3QMMeta || {},
    component: () => import("/home/runner/work/1/s/pages/index.vue")
  },
  {
    name: "index___en-asia-pacific",
    path: "/en-asia-pacific",
    meta: indextaeU1Rv2PODclhn_AsI5UxzQ2xvK5IkFXgTj7NPk3QMMeta || {},
    component: () => import("/home/runner/work/1/s/pages/index.vue")
  },
  {
    name: "index___ja-jp",
    path: "/ja-jp",
    meta: indextaeU1Rv2PODclhn_AsI5UxzQ2xvK5IkFXgTj7NPk3QMMeta || {},
    component: () => import("/home/runner/work/1/s/pages/index.vue")
  },
  {
    name: "index___zh-cn",
    path: "/zh-cn",
    meta: indextaeU1Rv2PODclhn_AsI5UxzQ2xvK5IkFXgTj7NPk3QMMeta || {},
    component: () => import("/home/runner/work/1/s/pages/index.vue")
  },
  {
    name: "index___zh-tw",
    path: "/zh-tw",
    meta: indextaeU1Rv2PODclhn_AsI5UxzQ2xvK5IkFXgTj7NPk3QMMeta || {},
    component: () => import("/home/runner/work/1/s/pages/index.vue")
  },
  {
    name: "marketplace___en-int",
    path: "/en-int/marketplace",
    component: () => import("/home/runner/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___en-emea",
    path: "/en-emea/marketplace",
    component: () => import("/home/runner/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___en-jp",
    path: "/en-jp/marketplace",
    component: () => import("/home/runner/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___en-tw",
    path: "/en-tw/marketplace",
    component: () => import("/home/runner/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___en-kr",
    path: "/en-kr/marketplace",
    component: () => import("/home/runner/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___en-americas",
    path: "/en-americas/marketplace",
    component: () => import("/home/runner/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___en-asia-pacific",
    path: "/en-asia-pacific/marketplace",
    component: () => import("/home/runner/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___ja-jp",
    path: "/ja-jp/marketplace",
    component: () => import("/home/runner/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___zh-cn",
    path: "/zh-cn/marketplace",
    component: () => import("/home/runner/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace___zh-tw",
    path: "/zh-tw/marketplace",
    component: () => import("/home/runner/work/1/s/pages/marketplace/index.vue")
  },
  {
    name: "marketplace-news___en-int",
    path: "/en-int/marketplace/news",
    meta: indexzkD5QlTHSU4nSpmOCngPvsn6sUZSzAt4YZTXrnyCcTkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___en-emea",
    path: "/en-emea/marketplace/news",
    meta: indexzkD5QlTHSU4nSpmOCngPvsn6sUZSzAt4YZTXrnyCcTkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___en-jp",
    path: "/en-jp/marketplace/news",
    meta: indexzkD5QlTHSU4nSpmOCngPvsn6sUZSzAt4YZTXrnyCcTkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___en-tw",
    path: "/en-tw/marketplace/news",
    meta: indexzkD5QlTHSU4nSpmOCngPvsn6sUZSzAt4YZTXrnyCcTkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___en-kr",
    path: "/en-kr/marketplace/news",
    meta: indexzkD5QlTHSU4nSpmOCngPvsn6sUZSzAt4YZTXrnyCcTkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___en-americas",
    path: "/en-americas/marketplace/news",
    meta: indexzkD5QlTHSU4nSpmOCngPvsn6sUZSzAt4YZTXrnyCcTkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/news",
    meta: indexzkD5QlTHSU4nSpmOCngPvsn6sUZSzAt4YZTXrnyCcTkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___ja-jp",
    path: "/ja-jp/marketplace/news",
    meta: indexzkD5QlTHSU4nSpmOCngPvsn6sUZSzAt4YZTXrnyCcTkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___zh-cn",
    path: "/zh-cn/marketplace/news",
    meta: indexzkD5QlTHSU4nSpmOCngPvsn6sUZSzAt4YZTXrnyCcTkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-news___zh-tw",
    path: "/zh-tw/marketplace/news",
    meta: indexzkD5QlTHSU4nSpmOCngPvsn6sUZSzAt4YZTXrnyCcTkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/news/index.vue")
  },
  {
    name: "marketplace-search___en-int",
    path: "/en-int/marketplace/search",
    component: () => import("/home/runner/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___en-emea",
    path: "/en-emea/marketplace/search",
    component: () => import("/home/runner/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___en-jp",
    path: "/en-jp/marketplace/search",
    component: () => import("/home/runner/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___en-tw",
    path: "/en-tw/marketplace/search",
    component: () => import("/home/runner/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___en-kr",
    path: "/en-kr/marketplace/search",
    component: () => import("/home/runner/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___en-americas",
    path: "/en-americas/marketplace/search",
    component: () => import("/home/runner/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/search",
    component: () => import("/home/runner/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___ja-jp",
    path: "/ja-jp/marketplace/search",
    component: () => import("/home/runner/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___zh-cn",
    path: "/zh-cn/marketplace/search",
    component: () => import("/home/runner/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-search___zh-tw",
    path: "/zh-tw/marketplace/search",
    component: () => import("/home/runner/work/1/s/pages/marketplace/search/index.vue")
  },
  {
    name: "marketplace-support___en-int",
    path: "/en-int/marketplace/support",
    meta: indexpsVTI_hQN2ssw_PJKXpw_IoX0MXIAVu6bbB5_45z4FPAwMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___en-emea",
    path: "/en-emea/marketplace/support",
    meta: indexpsVTI_hQN2ssw_PJKXpw_IoX0MXIAVu6bbB5_45z4FPAwMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___en-jp",
    path: "/en-jp/marketplace/support",
    meta: indexpsVTI_hQN2ssw_PJKXpw_IoX0MXIAVu6bbB5_45z4FPAwMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___en-tw",
    path: "/en-tw/marketplace/support",
    meta: indexpsVTI_hQN2ssw_PJKXpw_IoX0MXIAVu6bbB5_45z4FPAwMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___en-kr",
    path: "/en-kr/marketplace/support",
    meta: indexpsVTI_hQN2ssw_PJKXpw_IoX0MXIAVu6bbB5_45z4FPAwMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___en-americas",
    path: "/en-americas/marketplace/support",
    meta: indexpsVTI_hQN2ssw_PJKXpw_IoX0MXIAVu6bbB5_45z4FPAwMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/support",
    meta: indexpsVTI_hQN2ssw_PJKXpw_IoX0MXIAVu6bbB5_45z4FPAwMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___ja-jp",
    path: "/ja-jp/marketplace/support",
    meta: indexpsVTI_hQN2ssw_PJKXpw_IoX0MXIAVu6bbB5_45z4FPAwMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___zh-cn",
    path: "/zh-cn/marketplace/support",
    meta: indexpsVTI_hQN2ssw_PJKXpw_IoX0MXIAVu6bbB5_45z4FPAwMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-support___zh-tw",
    path: "/zh-tw/marketplace/support",
    meta: indexpsVTI_hQN2ssw_PJKXpw_IoX0MXIAVu6bbB5_45z4FPAwMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/index.vue")
  },
  {
    name: "marketplace-about-us___en-int",
    path: "/en-int/marketplace/about-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___en-emea",
    path: "/en-emea/marketplace/about-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___en-jp",
    path: "/en-jp/marketplace/about-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___en-tw",
    path: "/en-tw/marketplace/about-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___en-kr",
    path: "/en-kr/marketplace/about-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___en-americas",
    path: "/en-americas/marketplace/about-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/about-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___ja-jp",
    path: "/ja-jp/marketplace/about-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___zh-cn",
    path: "/zh-cn/marketplace/about-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-about-us___zh-tw",
    path: "/zh-tw/marketplace/about-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/about-us/index.vue")
  },
  {
    name: "marketplace-partners___en-int",
    path: "/en-int/marketplace/partners",
    meta: index8K1sJp_45kLY6rP6HCvAqcsctAKqFNp9wD_K8BUSxiHNAMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___en-emea",
    path: "/en-emea/marketplace/partners",
    meta: index8K1sJp_45kLY6rP6HCvAqcsctAKqFNp9wD_K8BUSxiHNAMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___en-jp",
    path: "/en-jp/marketplace/partners",
    meta: index8K1sJp_45kLY6rP6HCvAqcsctAKqFNp9wD_K8BUSxiHNAMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___en-tw",
    path: "/en-tw/marketplace/partners",
    meta: index8K1sJp_45kLY6rP6HCvAqcsctAKqFNp9wD_K8BUSxiHNAMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___en-kr",
    path: "/en-kr/marketplace/partners",
    meta: index8K1sJp_45kLY6rP6HCvAqcsctAKqFNp9wD_K8BUSxiHNAMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___en-americas",
    path: "/en-americas/marketplace/partners",
    meta: index8K1sJp_45kLY6rP6HCvAqcsctAKqFNp9wD_K8BUSxiHNAMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/partners",
    meta: index8K1sJp_45kLY6rP6HCvAqcsctAKqFNp9wD_K8BUSxiHNAMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___ja-jp",
    path: "/ja-jp/marketplace/partners",
    meta: index8K1sJp_45kLY6rP6HCvAqcsctAKqFNp9wD_K8BUSxiHNAMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___zh-cn",
    path: "/zh-cn/marketplace/partners",
    meta: index8K1sJp_45kLY6rP6HCvAqcsctAKqFNp9wD_K8BUSxiHNAMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-partners___zh-tw",
    path: "/zh-tw/marketplace/partners",
    meta: index8K1sJp_45kLY6rP6HCvAqcsctAKqFNp9wD_K8BUSxiHNAMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/index.vue")
  },
  {
    name: "marketplace-webinars___en-int",
    path: "/en-int/marketplace/webinars",
    meta: indexY9XveV6TxZfvx7eAOrvgb12BFY3Qbc2AowYuCEwiy2YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___en-emea",
    path: "/en-emea/marketplace/webinars",
    meta: indexY9XveV6TxZfvx7eAOrvgb12BFY3Qbc2AowYuCEwiy2YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___en-jp",
    path: "/en-jp/marketplace/webinars",
    meta: indexY9XveV6TxZfvx7eAOrvgb12BFY3Qbc2AowYuCEwiy2YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___en-tw",
    path: "/en-tw/marketplace/webinars",
    meta: indexY9XveV6TxZfvx7eAOrvgb12BFY3Qbc2AowYuCEwiy2YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___en-kr",
    path: "/en-kr/marketplace/webinars",
    meta: indexY9XveV6TxZfvx7eAOrvgb12BFY3Qbc2AowYuCEwiy2YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___en-americas",
    path: "/en-americas/marketplace/webinars",
    meta: indexY9XveV6TxZfvx7eAOrvgb12BFY3Qbc2AowYuCEwiy2YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/webinars",
    meta: indexY9XveV6TxZfvx7eAOrvgb12BFY3Qbc2AowYuCEwiy2YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___ja-jp",
    path: "/ja-jp/marketplace/webinars",
    meta: indexY9XveV6TxZfvx7eAOrvgb12BFY3Qbc2AowYuCEwiy2YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___zh-cn",
    path: "/zh-cn/marketplace/webinars",
    meta: indexY9XveV6TxZfvx7eAOrvgb12BFY3Qbc2AowYuCEwiy2YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-webinars___zh-tw",
    path: "/zh-tw/marketplace/webinars",
    meta: indexY9XveV6TxZfvx7eAOrvgb12BFY3Qbc2AowYuCEwiy2YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/webinars/index.vue")
  },
  {
    name: "marketplace-free-trial___en-int",
    path: "/en-int/marketplace/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___en-emea",
    path: "/en-emea/marketplace/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___en-jp",
    path: "/en-jp/marketplace/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___en-tw",
    path: "/en-tw/marketplace/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___en-kr",
    path: "/en-kr/marketplace/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___en-americas",
    path: "/en-americas/marketplace/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___ja-jp",
    path: "/ja-jp/marketplace/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___zh-cn",
    path: "/zh-cn/marketplace/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-free-trial___zh-tw",
    path: "/zh-tw/marketplace/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/free-trial/index.vue")
  },
  {
    name: "marketplace-Membership___en-int",
    path: "/en-int/marketplace/Membership",
    component: () => import("/home/runner/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___en-emea",
    path: "/en-emea/marketplace/Membership",
    component: () => import("/home/runner/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___en-jp",
    path: "/en-jp/marketplace/Membership",
    component: () => import("/home/runner/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___en-tw",
    path: "/en-tw/marketplace/Membership",
    component: () => import("/home/runner/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___en-kr",
    path: "/en-kr/marketplace/Membership",
    component: () => import("/home/runner/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___en-americas",
    path: "/en-americas/marketplace/Membership",
    component: () => import("/home/runner/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/Membership",
    component: () => import("/home/runner/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___ja-jp",
    path: "/ja-jp/marketplace/Membership",
    component: () => import("/home/runner/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___zh-cn",
    path: "/zh-cn/marketplace/Membership",
    component: () => import("/home/runner/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-Membership___zh-tw",
    path: "/zh-tw/marketplace/Membership",
    component: () => import("/home/runner/work/1/s/pages/marketplace/Membership/index.vue")
  },
  {
    name: "marketplace-pricing-id___en-int",
    path: "/en-int/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___en-emea",
    path: "/en-emea/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___en-jp",
    path: "/en-jp/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___en-tw",
    path: "/en-tw/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___en-kr",
    path: "/en-kr/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___en-americas",
    path: "/en-americas/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___ja-jp",
    path: "/ja-jp/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___zh-cn",
    path: "/zh-cn/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-pricing-id___zh-tw",
    path: "/zh-tw/marketplace/pricing/:id()",
    meta: {"middleware":["pricing-plan-redirect"]},
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/index.vue")
  },
  {
    name: "marketplace-materials-details___en-int",
    path: "/en-int/marketplace/materials/:details()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___en-emea",
    path: "/en-emea/marketplace/materials/:details()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___en-jp",
    path: "/en-jp/marketplace/materials/:details()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___en-tw",
    path: "/en-tw/marketplace/materials/:details()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___en-kr",
    path: "/en-kr/marketplace/materials/:details()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___en-americas",
    path: "/en-americas/marketplace/materials/:details()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/materials/:details()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___ja-jp",
    path: "/ja-jp/marketplace/materials/:details()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___zh-cn",
    path: "/zh-cn/marketplace/materials/:details()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-materials-details___zh-tw",
    path: "/zh-tw/marketplace/materials/:details()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/materials/[details].vue")
  },
  {
    name: "marketplace-products-id___en-int",
    path: "/en-int/marketplace/products/:id()",
    meta: { ...(index06FdUtUOAmONErkzGVdrxAzj0LJTaPj_xkeD_127X3kMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___en-emea",
    path: "/en-emea/marketplace/products/:id()",
    meta: { ...(index06FdUtUOAmONErkzGVdrxAzj0LJTaPj_xkeD_127X3kMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___en-jp",
    path: "/en-jp/marketplace/products/:id()",
    meta: { ...(index06FdUtUOAmONErkzGVdrxAzj0LJTaPj_xkeD_127X3kMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___en-tw",
    path: "/en-tw/marketplace/products/:id()",
    meta: { ...(index06FdUtUOAmONErkzGVdrxAzj0LJTaPj_xkeD_127X3kMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___en-kr",
    path: "/en-kr/marketplace/products/:id()",
    meta: { ...(index06FdUtUOAmONErkzGVdrxAzj0LJTaPj_xkeD_127X3kMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___en-americas",
    path: "/en-americas/marketplace/products/:id()",
    meta: { ...(index06FdUtUOAmONErkzGVdrxAzj0LJTaPj_xkeD_127X3kMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/products/:id()",
    meta: { ...(index06FdUtUOAmONErkzGVdrxAzj0LJTaPj_xkeD_127X3kMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___ja-jp",
    path: "/ja-jp/marketplace/products/:id()",
    meta: { ...(index06FdUtUOAmONErkzGVdrxAzj0LJTaPj_xkeD_127X3kMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___zh-cn",
    path: "/zh-cn/marketplace/products/:id()",
    meta: { ...(index06FdUtUOAmONErkzGVdrxAzj0LJTaPj_xkeD_127X3kMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-products-id___zh-tw",
    path: "/zh-tw/marketplace/products/:id()",
    meta: { ...(index06FdUtUOAmONErkzGVdrxAzj0LJTaPj_xkeD_127X3kMeta || {}), ...{"middleware":["product-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/index.vue")
  },
  {
    name: "marketplace-help-contact-us___en-int",
    path: "/en-int/marketplace/help/contact-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___en-emea",
    path: "/en-emea/marketplace/help/contact-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___en-jp",
    path: "/en-jp/marketplace/help/contact-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___en-tw",
    path: "/en-tw/marketplace/help/contact-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___en-kr",
    path: "/en-kr/marketplace/help/contact-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___en-americas",
    path: "/en-americas/marketplace/help/contact-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/help/contact-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___ja-jp",
    path: "/ja-jp/marketplace/help/contact-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___zh-cn",
    path: "/zh-cn/marketplace/help/contact-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-help-contact-us___zh-tw",
    path: "/zh-tw/marketplace/help/contact-us",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/contact-us/index.vue")
  },
  {
    name: "marketplace-products-id-slug___en-int",
    path: "/en-int/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93L4neUMNJ4BuKhcc1kgX2s_45wXHqHU9B8nwkWMCcpSG1YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___en-emea",
    path: "/en-emea/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93L4neUMNJ4BuKhcc1kgX2s_45wXHqHU9B8nwkWMCcpSG1YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___en-jp",
    path: "/en-jp/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93L4neUMNJ4BuKhcc1kgX2s_45wXHqHU9B8nwkWMCcpSG1YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___en-tw",
    path: "/en-tw/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93L4neUMNJ4BuKhcc1kgX2s_45wXHqHU9B8nwkWMCcpSG1YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___en-kr",
    path: "/en-kr/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93L4neUMNJ4BuKhcc1kgX2s_45wXHqHU9B8nwkWMCcpSG1YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___en-americas",
    path: "/en-americas/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93L4neUMNJ4BuKhcc1kgX2s_45wXHqHU9B8nwkWMCcpSG1YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93L4neUMNJ4BuKhcc1kgX2s_45wXHqHU9B8nwkWMCcpSG1YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___ja-jp",
    path: "/ja-jp/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93L4neUMNJ4BuKhcc1kgX2s_45wXHqHU9B8nwkWMCcpSG1YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___zh-cn",
    path: "/zh-cn/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93L4neUMNJ4BuKhcc1kgX2s_45wXHqHU9B8nwkWMCcpSG1YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-products-id-slug___zh-tw",
    path: "/zh-tw/marketplace/products/:id()/:slug(.*)*",
    meta: _91_46_46_46slug_93L4neUMNJ4BuKhcc1kgX2s_45wXHqHU9B8nwkWMCcpSG1YMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/[...slug].vue")
  },
  {
    name: "marketplace-help-sales-support___en-int",
    path: "/en-int/marketplace/help/sales-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___en-emea",
    path: "/en-emea/marketplace/help/sales-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___en-jp",
    path: "/en-jp/marketplace/help/sales-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___en-tw",
    path: "/en-tw/marketplace/help/sales-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___en-kr",
    path: "/en-kr/marketplace/help/sales-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___en-americas",
    path: "/en-americas/marketplace/help/sales-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/help/sales-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___ja-jp",
    path: "/ja-jp/marketplace/help/sales-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___zh-cn",
    path: "/zh-cn/marketplace/help/sales-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-help-sales-support___zh-tw",
    path: "/zh-tw/marketplace/help/sales-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/sales-support/index.vue")
  },
  {
    name: "marketplace-support-support-hub___en-int",
    path: "/en-int/marketplace/support/support-hub",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___en-emea",
    path: "/en-emea/marketplace/support/support-hub",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___en-jp",
    path: "/en-jp/marketplace/support/support-hub",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___en-tw",
    path: "/en-tw/marketplace/support/support-hub",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___en-kr",
    path: "/en-kr/marketplace/support/support-hub",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___en-americas",
    path: "/en-americas/marketplace/support/support-hub",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/support/support-hub",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___ja-jp",
    path: "/ja-jp/marketplace/support/support-hub",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___zh-cn",
    path: "/zh-cn/marketplace/support/support-hub",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-support-support-hub___zh-tw",
    path: "/zh-tw/marketplace/support/support-hub",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/support-hub/index.vue")
  },
  {
    name: "marketplace-solutions-solution___en-int",
    path: "/en-int/marketplace/solutions/:solution()",
    meta: indexa280vM9__4C8Fapng9aB_45Rr_45CoaeOQXS1Xn9fsOAVmkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___en-emea",
    path: "/en-emea/marketplace/solutions/:solution()",
    meta: indexa280vM9__4C8Fapng9aB_45Rr_45CoaeOQXS1Xn9fsOAVmkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___en-jp",
    path: "/en-jp/marketplace/solutions/:solution()",
    meta: indexa280vM9__4C8Fapng9aB_45Rr_45CoaeOQXS1Xn9fsOAVmkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___en-tw",
    path: "/en-tw/marketplace/solutions/:solution()",
    meta: indexa280vM9__4C8Fapng9aB_45Rr_45CoaeOQXS1Xn9fsOAVmkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___en-kr",
    path: "/en-kr/marketplace/solutions/:solution()",
    meta: indexa280vM9__4C8Fapng9aB_45Rr_45CoaeOQXS1Xn9fsOAVmkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___en-americas",
    path: "/en-americas/marketplace/solutions/:solution()",
    meta: indexa280vM9__4C8Fapng9aB_45Rr_45CoaeOQXS1Xn9fsOAVmkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/solutions/:solution()",
    meta: indexa280vM9__4C8Fapng9aB_45Rr_45CoaeOQXS1Xn9fsOAVmkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___ja-jp",
    path: "/ja-jp/marketplace/solutions/:solution()",
    meta: indexa280vM9__4C8Fapng9aB_45Rr_45CoaeOQXS1Xn9fsOAVmkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___zh-cn",
    path: "/zh-cn/marketplace/solutions/:solution()",
    meta: indexa280vM9__4C8Fapng9aB_45Rr_45CoaeOQXS1Xn9fsOAVmkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-solutions-solution___zh-tw",
    path: "/zh-tw/marketplace/solutions/:solution()",
    meta: indexa280vM9__4C8Fapng9aB_45Rr_45CoaeOQXS1Xn9fsOAVmkMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___en-int",
    path: "/en-int/marketplace/category/:subcategory()",
    meta: { ...(indextRBs6RYD7aJ9tQHJOuZUmM2_45keSLqJIJjm7FOIxStLkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___en-emea",
    path: "/en-emea/marketplace/category/:subcategory()",
    meta: { ...(indextRBs6RYD7aJ9tQHJOuZUmM2_45keSLqJIJjm7FOIxStLkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___en-jp",
    path: "/en-jp/marketplace/category/:subcategory()",
    meta: { ...(indextRBs6RYD7aJ9tQHJOuZUmM2_45keSLqJIJjm7FOIxStLkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___en-tw",
    path: "/en-tw/marketplace/category/:subcategory()",
    meta: { ...(indextRBs6RYD7aJ9tQHJOuZUmM2_45keSLqJIJjm7FOIxStLkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___en-kr",
    path: "/en-kr/marketplace/category/:subcategory()",
    meta: { ...(indextRBs6RYD7aJ9tQHJOuZUmM2_45keSLqJIJjm7FOIxStLkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___en-americas",
    path: "/en-americas/marketplace/category/:subcategory()",
    meta: { ...(indextRBs6RYD7aJ9tQHJOuZUmM2_45keSLqJIJjm7FOIxStLkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/category/:subcategory()",
    meta: { ...(indextRBs6RYD7aJ9tQHJOuZUmM2_45keSLqJIJjm7FOIxStLkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___ja-jp",
    path: "/ja-jp/marketplace/category/:subcategory()",
    meta: { ...(indextRBs6RYD7aJ9tQHJOuZUmM2_45keSLqJIJjm7FOIxStLkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___zh-cn",
    path: "/zh-cn/marketplace/category/:subcategory()",
    meta: { ...(indextRBs6RYD7aJ9tQHJOuZUmM2_45keSLqJIJjm7FOIxStLkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-category-subcategory___zh-tw",
    path: "/zh-tw/marketplace/category/:subcategory()",
    meta: { ...(indextRBs6RYD7aJ9tQHJOuZUmM2_45keSLqJIJjm7FOIxStLkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/index.vue")
  },
  {
    name: "marketplace-help-technical-support___en-int",
    path: "/en-int/marketplace/help/technical-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___en-emea",
    path: "/en-emea/marketplace/help/technical-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___en-jp",
    path: "/en-jp/marketplace/help/technical-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___en-tw",
    path: "/en-tw/marketplace/help/technical-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___en-kr",
    path: "/en-kr/marketplace/help/technical-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___en-americas",
    path: "/en-americas/marketplace/help/technical-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/help/technical-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___ja-jp",
    path: "/ja-jp/marketplace/help/technical-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___zh-cn",
    path: "/zh-cn/marketplace/help/technical-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-help-technical-support___zh-tw",
    path: "/zh-tw/marketplace/help/technical-support",
    component: () => import("/home/runner/work/1/s/pages/marketplace/help/technical-support/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___en-int",
    path: "/en-int/marketplace/redirect/report-center",
    meta: indexL4OeEmtLqEu1P2aNYX82vTDH9hDquRgDUo6NBM_LTBEMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___en-emea",
    path: "/en-emea/marketplace/redirect/report-center",
    meta: indexL4OeEmtLqEu1P2aNYX82vTDH9hDquRgDUo6NBM_LTBEMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___en-jp",
    path: "/en-jp/marketplace/redirect/report-center",
    meta: indexL4OeEmtLqEu1P2aNYX82vTDH9hDquRgDUo6NBM_LTBEMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___en-tw",
    path: "/en-tw/marketplace/redirect/report-center",
    meta: indexL4OeEmtLqEu1P2aNYX82vTDH9hDquRgDUo6NBM_LTBEMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___en-kr",
    path: "/en-kr/marketplace/redirect/report-center",
    meta: indexL4OeEmtLqEu1P2aNYX82vTDH9hDquRgDUo6NBM_LTBEMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___en-americas",
    path: "/en-americas/marketplace/redirect/report-center",
    meta: indexL4OeEmtLqEu1P2aNYX82vTDH9hDquRgDUo6NBM_LTBEMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/redirect/report-center",
    meta: indexL4OeEmtLqEu1P2aNYX82vTDH9hDquRgDUo6NBM_LTBEMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___ja-jp",
    path: "/ja-jp/marketplace/redirect/report-center",
    meta: indexL4OeEmtLqEu1P2aNYX82vTDH9hDquRgDUo6NBM_LTBEMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___zh-cn",
    path: "/zh-cn/marketplace/redirect/report-center",
    meta: indexL4OeEmtLqEu1P2aNYX82vTDH9hDquRgDUo6NBM_LTBEMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-redirect-report-center___zh-tw",
    path: "/zh-tw/marketplace/redirect/report-center",
    meta: indexL4OeEmtLqEu1P2aNYX82vTDH9hDquRgDUo6NBM_LTBEMeta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/redirect/report-center/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___en-int",
    path: "/en-int/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___en-emea",
    path: "/en-emea/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___en-jp",
    path: "/en-jp/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___en-tw",
    path: "/en-tw/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___en-kr",
    path: "/en-kr/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___en-americas",
    path: "/en-americas/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___ja-jp",
    path: "/ja-jp/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___zh-cn",
    path: "/zh-cn/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-cta-booking-trackingId___zh-tw",
    path: "/zh-tw/marketplace/cta/booking/:trackingId()",
    component: () => import("/home/runner/work/1/s/pages/marketplace/cta/booking/[trackingId]/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___en-int",
    path: "/en-int/marketplace/topics/digital-om-energy",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___en-emea",
    path: "/en-emea/marketplace/topics/digital-om-energy",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___en-jp",
    path: "/en-jp/marketplace/topics/digital-om-energy",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___en-tw",
    path: "/en-tw/marketplace/topics/digital-om-energy",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___en-kr",
    path: "/en-kr/marketplace/topics/digital-om-energy",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___en-americas",
    path: "/en-americas/marketplace/topics/digital-om-energy",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/topics/digital-om-energy",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___ja-jp",
    path: "/ja-jp/marketplace/topics/digital-om-energy",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___zh-cn",
    path: "/zh-cn/marketplace/topics/digital-om-energy",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-topics-digital-om-energy___zh-tw",
    path: "/zh-tw/marketplace/topics/digital-om-energy",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/digital-om-energy/index.vue")
  },
  {
    name: "marketplace-partners-program-overview___en-int",
    path: "/en-int/marketplace/partners/program-overview",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/program-overview/index.vue")
  },
  {
    name: "marketplace-partners-program-overview___en-emea",
    path: "/en-emea/marketplace/partners/program-overview",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/program-overview/index.vue")
  },
  {
    name: "marketplace-partners-program-overview___en-jp",
    path: "/en-jp/marketplace/partners/program-overview",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/program-overview/index.vue")
  },
  {
    name: "marketplace-partners-program-overview___en-tw",
    path: "/en-tw/marketplace/partners/program-overview",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/program-overview/index.vue")
  },
  {
    name: "marketplace-partners-program-overview___en-kr",
    path: "/en-kr/marketplace/partners/program-overview",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/program-overview/index.vue")
  },
  {
    name: "marketplace-partners-program-overview___en-americas",
    path: "/en-americas/marketplace/partners/program-overview",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/program-overview/index.vue")
  },
  {
    name: "marketplace-partners-program-overview___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/partners/program-overview",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/program-overview/index.vue")
  },
  {
    name: "marketplace-partners-program-overview___ja-jp",
    path: "/ja-jp/marketplace/partners/program-overview",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/program-overview/index.vue")
  },
  {
    name: "marketplace-partners-program-overview___zh-cn",
    path: "/zh-cn/marketplace/partners/program-overview",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/program-overview/index.vue")
  },
  {
    name: "marketplace-partners-program-overview___zh-tw",
    path: "/zh-tw/marketplace/partners/program-overview",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/program-overview/index.vue")
  },
  {
    name: "marketplace-category-subcategory-generic___en-int",
    path: "/en-int/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93fOjF2IINMlEbJu4CcfWUI6Ou1q4rq7Ijv7uamlWbOtkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___en-emea",
    path: "/en-emea/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93fOjF2IINMlEbJu4CcfWUI6Ou1q4rq7Ijv7uamlWbOtkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___en-jp",
    path: "/en-jp/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93fOjF2IINMlEbJu4CcfWUI6Ou1q4rq7Ijv7uamlWbOtkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___en-tw",
    path: "/en-tw/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93fOjF2IINMlEbJu4CcfWUI6Ou1q4rq7Ijv7uamlWbOtkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___en-kr",
    path: "/en-kr/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93fOjF2IINMlEbJu4CcfWUI6Ou1q4rq7Ijv7uamlWbOtkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___en-americas",
    path: "/en-americas/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93fOjF2IINMlEbJu4CcfWUI6Ou1q4rq7Ijv7uamlWbOtkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93fOjF2IINMlEbJu4CcfWUI6Ou1q4rq7Ijv7uamlWbOtkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___ja-jp",
    path: "/ja-jp/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93fOjF2IINMlEbJu4CcfWUI6Ou1q4rq7Ijv7uamlWbOtkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___zh-cn",
    path: "/zh-cn/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93fOjF2IINMlEbJu4CcfWUI6Ou1q4rq7Ijv7uamlWbOtkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-category-subcategory-generic___zh-tw",
    path: "/zh-tw/marketplace/category/:subcategory()/:generic()",
    meta: { ...(_91generic_93fOjF2IINMlEbJu4CcfWUI6Ou1q4rq7Ijv7uamlWbOtkMeta || {}), ...{"middleware":["category-redirect"]} },
    component: () => import("/home/runner/work/1/s/pages/marketplace/category/[subcategory]/[generic].vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___en-int",
    path: "/en-int/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___en-emea",
    path: "/en-emea/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___en-jp",
    path: "/en-jp/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___en-tw",
    path: "/en-tw/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___en-kr",
    path: "/en-kr/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___en-americas",
    path: "/en-americas/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___ja-jp",
    path: "/ja-jp/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___zh-cn",
    path: "/zh-cn/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-contact-sales___zh-tw",
    path: "/zh-tw/marketplace/pricing/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___en-int",
    path: "/en-int/marketplace/products/:id()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___en-emea",
    path: "/en-emea/marketplace/products/:id()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___en-jp",
    path: "/en-jp/marketplace/products/:id()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___en-tw",
    path: "/en-tw/marketplace/products/:id()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___en-kr",
    path: "/en-kr/marketplace/products/:id()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___en-americas",
    path: "/en-americas/marketplace/products/:id()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/products/:id()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___ja-jp",
    path: "/ja-jp/marketplace/products/:id()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___zh-cn",
    path: "/zh-cn/marketplace/products/:id()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-products-id-request-demo___zh-tw",
    path: "/zh-tw/marketplace/products/:id()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/request-demo/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___en-int",
    path: "/en-int/marketplace/support/certificated-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___en-emea",
    path: "/en-emea/marketplace/support/certificated-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___en-jp",
    path: "/en-jp/marketplace/support/certificated-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___en-tw",
    path: "/en-tw/marketplace/support/certificated-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___en-kr",
    path: "/en-kr/marketplace/support/certificated-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___en-americas",
    path: "/en-americas/marketplace/support/certificated-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/support/certificated-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___ja-jp",
    path: "/ja-jp/marketplace/support/certificated-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___zh-cn",
    path: "/zh-cn/marketplace/support/certificated-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-support-certificated-sales___zh-tw",
    path: "/zh-tw/marketplace/support/certificated-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/support/certificated-sales/index.vue")
  },
  {
    name: "marketplace-partners-si-partner-program___en-int",
    path: "/en-int/marketplace/partners/si-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/si-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-si-partner-program___en-emea",
    path: "/en-emea/marketplace/partners/si-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/si-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-si-partner-program___en-jp",
    path: "/en-jp/marketplace/partners/si-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/si-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-si-partner-program___en-tw",
    path: "/en-tw/marketplace/partners/si-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/si-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-si-partner-program___en-kr",
    path: "/en-kr/marketplace/partners/si-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/si-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-si-partner-program___en-americas",
    path: "/en-americas/marketplace/partners/si-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/si-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-si-partner-program___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/partners/si-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/si-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-si-partner-program___ja-jp",
    path: "/ja-jp/marketplace/partners/si-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/si-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-si-partner-program___zh-cn",
    path: "/zh-cn/marketplace/partners/si-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/si-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-si-partner-program___zh-tw",
    path: "/zh-tw/marketplace/partners/si-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/si-partner-program/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___en-int",
    path: "/en-int/marketplace/products/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___en-emea",
    path: "/en-emea/marketplace/products/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___en-jp",
    path: "/en-jp/marketplace/products/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___en-tw",
    path: "/en-tw/marketplace/products/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___en-kr",
    path: "/en-kr/marketplace/products/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___en-americas",
    path: "/en-americas/marketplace/products/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/products/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___ja-jp",
    path: "/ja-jp/marketplace/products/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___zh-cn",
    path: "/zh-cn/marketplace/products/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-products-id-contact-sales___zh-tw",
    path: "/zh-tw/marketplace/products/:id()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/products/[id]/contact-sales/index.vue")
  },
  {
    name: "marketplace-partners-isv-partner-program___en-int",
    path: "/en-int/marketplace/partners/isv-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/isv-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-isv-partner-program___en-emea",
    path: "/en-emea/marketplace/partners/isv-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/isv-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-isv-partner-program___en-jp",
    path: "/en-jp/marketplace/partners/isv-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/isv-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-isv-partner-program___en-tw",
    path: "/en-tw/marketplace/partners/isv-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/isv-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-isv-partner-program___en-kr",
    path: "/en-kr/marketplace/partners/isv-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/isv-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-isv-partner-program___en-americas",
    path: "/en-americas/marketplace/partners/isv-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/isv-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-isv-partner-program___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/partners/isv-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/isv-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-isv-partner-program___ja-jp",
    path: "/ja-jp/marketplace/partners/isv-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/isv-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-isv-partner-program___zh-cn",
    path: "/zh-cn/marketplace/partners/isv-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/isv-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-isv-partner-program___zh-tw",
    path: "/zh-tw/marketplace/partners/isv-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/isv-partner-program/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___en-int",
    path: "/en-int/marketplace/solutions/:solution()/:generic()",
    meta: indexeua2IXmkqsUlo1cSSWY3M4xjKTELaib_45t5TQMkK_Di0Meta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___en-emea",
    path: "/en-emea/marketplace/solutions/:solution()/:generic()",
    meta: indexeua2IXmkqsUlo1cSSWY3M4xjKTELaib_45t5TQMkK_Di0Meta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___en-jp",
    path: "/en-jp/marketplace/solutions/:solution()/:generic()",
    meta: indexeua2IXmkqsUlo1cSSWY3M4xjKTELaib_45t5TQMkK_Di0Meta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___en-tw",
    path: "/en-tw/marketplace/solutions/:solution()/:generic()",
    meta: indexeua2IXmkqsUlo1cSSWY3M4xjKTELaib_45t5TQMkK_Di0Meta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___en-kr",
    path: "/en-kr/marketplace/solutions/:solution()/:generic()",
    meta: indexeua2IXmkqsUlo1cSSWY3M4xjKTELaib_45t5TQMkK_Di0Meta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___en-americas",
    path: "/en-americas/marketplace/solutions/:solution()/:generic()",
    meta: indexeua2IXmkqsUlo1cSSWY3M4xjKTELaib_45t5TQMkK_Di0Meta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/solutions/:solution()/:generic()",
    meta: indexeua2IXmkqsUlo1cSSWY3M4xjKTELaib_45t5TQMkK_Di0Meta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___ja-jp",
    path: "/ja-jp/marketplace/solutions/:solution()/:generic()",
    meta: indexeua2IXmkqsUlo1cSSWY3M4xjKTELaib_45t5TQMkK_Di0Meta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___zh-cn",
    path: "/zh-cn/marketplace/solutions/:solution()/:generic()",
    meta: indexeua2IXmkqsUlo1cSSWY3M4xjKTELaib_45t5TQMkK_Di0Meta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic___zh-tw",
    path: "/zh-tw/marketplace/solutions/:solution()/:generic()",
    meta: indexeua2IXmkqsUlo1cSSWY3M4xjKTELaib_45t5TQMkK_Di0Meta || {},
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/index.vue")
  },
  {
    name: "marketplace-partners-channel-partner-program___en-int",
    path: "/en-int/marketplace/partners/channel-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/channel-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-channel-partner-program___en-emea",
    path: "/en-emea/marketplace/partners/channel-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/channel-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-channel-partner-program___en-jp",
    path: "/en-jp/marketplace/partners/channel-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/channel-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-channel-partner-program___en-tw",
    path: "/en-tw/marketplace/partners/channel-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/channel-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-channel-partner-program___en-kr",
    path: "/en-kr/marketplace/partners/channel-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/channel-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-channel-partner-program___en-americas",
    path: "/en-americas/marketplace/partners/channel-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/channel-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-channel-partner-program___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/partners/channel-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/channel-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-channel-partner-program___ja-jp",
    path: "/ja-jp/marketplace/partners/channel-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/channel-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-channel-partner-program___zh-cn",
    path: "/zh-cn/marketplace/partners/channel-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/channel-partner-program/index.vue")
  },
  {
    name: "marketplace-partners-channel-partner-program___zh-tw",
    path: "/zh-tw/marketplace/partners/channel-partner-program",
    component: () => import("/home/runner/work/1/s/pages/marketplace/partners/channel-partner-program/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___en-int",
    path: "/en-int/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___en-emea",
    path: "/en-emea/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___en-jp",
    path: "/en-jp/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___en-tw",
    path: "/en-tw/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___en-kr",
    path: "/en-kr/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___en-americas",
    path: "/en-americas/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___ja-jp",
    path: "/ja-jp/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___zh-cn",
    path: "/zh-cn/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-request-demo___zh-tw",
    path: "/zh-tw/marketplace/solutions/:solution()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/request-demo/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___en-int",
    path: "/en-int/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___en-emea",
    path: "/en-emea/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___en-jp",
    path: "/en-jp/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___en-tw",
    path: "/en-tw/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___en-kr",
    path: "/en-kr/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___en-americas",
    path: "/en-americas/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___ja-jp",
    path: "/ja-jp/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___zh-cn",
    path: "/zh-cn/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-free-trial___zh-tw",
    path: "/zh-tw/marketplace/pricing/:id()/:partnumber()/free-trial",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/free-trial/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___en-int",
    path: "/en-int/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___en-emea",
    path: "/en-emea/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___en-jp",
    path: "/en-jp/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___en-tw",
    path: "/en-tw/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___en-kr",
    path: "/en-kr/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___en-americas",
    path: "/en-americas/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___ja-jp",
    path: "/ja-jp/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___zh-cn",
    path: "/zh-cn/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-pricing-id-partnumber-contact-sales___zh-tw",
    path: "/zh-tw/marketplace/pricing/:id()/:partnumber()/contact-sales",
    component: () => import("/home/runner/work/1/s/pages/marketplace/pricing/[id]/[partnumber]/contact-sales/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___en-int",
    path: "/en-int/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___en-emea",
    path: "/en-emea/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___en-jp",
    path: "/en-jp/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___en-tw",
    path: "/en-tw/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___en-kr",
    path: "/en-kr/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___en-americas",
    path: "/en-americas/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___ja-jp",
    path: "/ja-jp/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___zh-cn",
    path: "/zh-cn/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-topics-wise-edge-developer-architecture___zh-tw",
    path: "/zh-tw/marketplace/topics/wise-edge-developer-architecture",
    component: () => import("/home/runner/work/1/s/pages/marketplace/topics/wise-edge-developer-architecture/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___en-int",
    path: "/en-int/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___en-emea",
    path: "/en-emea/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___en-jp",
    path: "/en-jp/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___en-tw",
    path: "/en-tw/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___en-kr",
    path: "/en-kr/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___en-americas",
    path: "/en-americas/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___en-asia-pacific",
    path: "/en-asia-pacific/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___ja-jp",
    path: "/ja-jp/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___zh-cn",
    path: "/zh-cn/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: "marketplace-solutions-solution-generic-request-demo___zh-tw",
    path: "/zh-tw/marketplace/solutions/:solution()/:generic()/request-demo",
    component: () => import("/home/runner/work/1/s/pages/marketplace/solutions/[solution]/[generic]/request-demo/index.vue")
  },
  {
    name: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pwMeta?.name,
    path: "/en-int/sitemap.xml",
    component: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pw
  },
  {
    name: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pwMeta?.name,
    path: "/en-emea/sitemap.xml",
    component: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pw
  },
  {
    name: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pwMeta?.name,
    path: "/en-jp/sitemap.xml",
    component: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pw
  },
  {
    name: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pwMeta?.name,
    path: "/en-tw/sitemap.xml",
    component: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pw
  },
  {
    name: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pwMeta?.name,
    path: "/en-kr/sitemap.xml",
    component: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pw
  },
  {
    name: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pwMeta?.name,
    path: "/en-americas/sitemap.xml",
    component: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pw
  },
  {
    name: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pwMeta?.name,
    path: "/en-asia-pacific/sitemap.xml",
    component: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pw
  },
  {
    name: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pwMeta?.name,
    path: "/ja-jp/sitemap.xml",
    component: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pw
  },
  {
    name: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pwMeta?.name,
    path: "/zh-cn/sitemap.xml",
    component: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pw
  },
  {
    name: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pwMeta?.name,
    path: "/zh-tw/sitemap.xml",
    component: component_45stubZt7jY06oH4V_7Ro3wKore1e6zaWF1Mm1qgVnI8T47pw
  }
]